module.exports = __webpack_public_path__ + "img/energy_liuxiang.f78a813d.png";